import type { ReactNode } from 'react';

interface RoomSettingsHeaderProps {
  roomName: string;
  onBack: () => void;
  subtitle?: ReactNode;
}

/**
 * Settings page header.
 */
export function RoomSettingsHeader({ roomName, onBack, subtitle }: RoomSettingsHeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-bg-primary/80 backdrop-blur-lg border-b border-border">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-4 h-16">
          <button
            onClick={onBack}
            className="p-2 text-gray-400 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
            aria-label="Back"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <h1 className="font-semibold">Room Settings</h1>
            <p className="text-sm text-gray-400">{roomName}</p>
            {subtitle && <div className="text-xs text-gray-500">{subtitle}</div>}
          </div>
        </div>
      </div>
    </header>
  );
}
